import { useNavigate } from 'react-router';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <main className="bg-background text-foreground flex min-h-screen items-center justify-center px-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <span className="text-muted-foreground text-xs font-medium uppercase tracking-widest">
          404
        </span>
        <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
        <p className="text-muted-foreground max-w-sm text-sm">
          The page you were looking for doesn&apos;t exist. It may have been moved, renamed, or
          never existed in the first place.
        </p>
        <button
          type="button"
          onClick={() => {
            void navigate('/');
          }}
          className="bg-primary text-primary-foreground hover:bg-primary/90 mt-2 inline-flex items-center rounded-md px-4 py-2 text-sm font-medium transition-colors"
        >
          Go home
        </button>
      </div>
    </main>
  );
}
